<template>
  <div class="not-found">
    <div class="not-found-content">
      <h1>404</h1>
      <p>页面不存在</p>
      <p v-if="tip" class="tip">{{ tip }}</p>
      <div class="actions">
        <a class="btn btn-primary" :href="homeUrl">返回首页</a>
        <a class="btn btn-secondary" :href="marketUrl">去行情中心</a>
      </div>
    </div>
  </div>
</template>

<script>
import { pcDomain } from '@/utils/jumpLink/domain'

export default {
  name: 'NotFound',
  computed: {
    tip() {
      return (this.$route && this.$route.meta && this.$route.meta.tip) || ''
    },
    homeUrl() {
      return `${pcDomain}/`
    },
    marketUrl() {
      return `${pcDomain}/marketCenter/index.html`
    },
  },
}
</script>

<style scoped>
.not-found {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: #fff;
}

.not-found-content {
  text-align: center;
  padding: 0 24px;
}

.not-found-content h1 {
  font-size: 72px;
  color: #333;
  margin: 0;
}

.not-found-content p {
  font-size: 18px;
  color: #666;
  margin-top: 20px;
}

.not-found-content .tip {
  font-size: 14px;
  color: #999;
  margin-top: 8px;
}

.actions {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 28px;
}

.btn {
  display: inline-block;
  min-width: 120px;
  margin: 0 6px 12px;
  padding: 10px 16px;
  font-size: 14px;
  line-height: 1.4;
  text-decoration: none;
  border-radius: 4px;
  box-sizing: border-box;
}

.btn-primary {
  color: #fff;
  background: #c8161d;
}

.btn-secondary {
  color: #c8161d;
  background: #fff;
  border: 1px solid #c8161d;
}
</style>
